<button
  #button
  (click)="onClick()"
  [attr.aria-hidden]="ariaHidden() || null"
  [attr.aria-label]="(ariaLabel() | translate) || null"
  [attr.aria-describedby]="ariaDescribedBy() || null"
  [attr.data-test]="dataTest()"
  [attr.disabled]="isDisabled() ? true : null"
  [attr.id]="btnId()"
  [attr.tabindex]="tabindex() || null"
  [type]="btnType()"
  class="btn btn-link btn-link--{{ color() }} text-start {{ customCss() }}"
  type="button"
>
  @if (showSpinner()) {
    <span class="loading-spinner"></span>
  } @else {
    @if (prependIconClass()) {
      <i class="{{ prependIconClass() }} mr-2" aria-hidden="true"></i>
    }

    <span class="text-decoration-underline">
      <span [innerHTML]="label() | translate"></span>
    </span>

    @if (appendIconClass()) {
      <i class="{{ appendIconClass() }} ml-2" aria-hidden="true"></i>
    }
  }
</button>
